export default "__VITE_ASSET__BoVIFJyD__"